import type { SortDirection } from '../constants/direction'
import type { Bool, ID } from '../types/UtilityTypes'
import type { ServerTask } from './tasks'
import type { Department } from './departments'

export interface User {
    id: ID,
    name: string,
    first_name?: string,
    surname?: string,
    description: string,
    charge?: number,
    photo?: string,
    is_online?: boolean,
    active: boolean,
    is_blocked: boolean,
}
export interface ContactsUser {
    name: string,
    departments: string[]
    directions: string[]
    phone: string,
    email: string,
    position: string[],
    skype: string,
    watsapp: string
}

export const EMPTY_USER: User = {
    description: '',
    id: 0,
    name: '',
    active: true,
    is_blocked: false,
}

export interface Permission {
    id: number,
    group_id: number,
    code: string,
    name: string,
    created_at: string,
    updated_at: string,
}

export interface PermissionGroup {
    id: number,
    code: string,
    name: string,
    created_at: string,
    updated_at: string,
    permissions: Permission[],
}

export interface Role {
    id: number,
    title: string,
    is_admin: Bool,
    is_design: Bool,
    is_finplan: Bool,
    pivot: {
        id: number,
        user_id: number,
        role_id: number,
        dsgn_active: null | '1',
    },
    permissions: Permission[],
}

export type TaskDirection = 'by_number' | 'by_priority'

export const taskDirectionName = (direction?: TaskDirection | null): string => {
    return direction === 'by_number'? 'По номеру': 'По приоритету'
}

export interface ClientSettings {
    history_direction?: SortDirection,
    history_comments?: boolean,
    history_files?: boolean,
    tasks_direction?: TaskDirection | null,
}

export interface CurrentUser extends User {
    role?: Role,
    roles: Role[],
    permissions: string[],
    direction_id: number,
    settings: ClientSettings,
    notification_settings: Record<string, Bool>,
    notification_method_settings: Record<string, Bool>,
    new_projects: number,
    paused_projects: number,
    requested_tasks: number,
    targeted_tasks: number,
    notifications_count: number,
}

export interface CurrentUserUpdateData {
    role?: number,
    settings?: ClientSettings,
    notification_settings?: Record<string, Bool>,
    notification_method_settings?: Record<string, Bool>,
}

export interface UserWithDepartments extends User {
    departments: Department[],
}

export interface UserWithTasks extends UserWithDepartments {
    tasks: ServerTask[],
}
